module.exports = __webpack_public_path__ + "media/images/applicant/flow-mark-square-white-51759a3a5179c28e3870e00c50ceb9bd.svg";